export default __webpack_public_path__ + "static/media/user-placeholder.e6d58d1b.jpg";